<div class="flex flex-column">
  <p class="mt-0 mb-3">{{ 'PAGES.SIGNUP.CODE_SENT_DESCRIPTION' | translate }}</p>

  <form [formGroup]="codeForm">
    <label for="activationCode" [iosRequired]="true" class="block mb-1 text-color-secondary">
      {{ 'PAGES.SIGNUP.ACTIVATION_CODE' | translate }}
    </label>
    <input class="w-full pt-3 pl-3 pb-3" id="activationCode" formControlName="activationCode" type="text" pInputText />
    <small *ngIf="codeFormErr['activationCode']" class="p-error block mt-1">
      {{ codeFormErr['activationCode'] | translate }}
    </small>
  </form>

  <div class="flex justify-content-between mt-4">
    <button
      pButton
      [label]="getSendActivationCodeLabel()"
      (click)="sendActivationCode()"
      [loading]="isSendingActivationCode"
      [disabled]="isSendingActivationCode || activationCodeRetryTimeLeft > 0"
      class="p-button-outlined mr-2"
    ></button>

    <button
      pButton
      label="{{ 'BUTTONS.CONFIRM' | translate }}"
      (click)="confirmCode()"
      [disabled]="isSendingActivationCode || !isConfirmButtonActive"
    ></button>
  </div>
</div>
